<div class="blackdim"></div>
<div class="fullpage narrative" >
    <div class="modal">
        <h1>Opzioni partita</h1>
    </div>
    <div class="button" (click)="clickItem()">Ricomincia da capo!</div>
</div>